export default function appendURLParams(url, params) {
  const targetURL = new URL(url);
  params.forEach(([key, value]) => {
    targetURL.searchParams.append(key, value);
  });
  return targetURL;
}
